/**
 * @param lang - User-facing language code (e.g., 'en', 'zh', 'es')
 * @returns Tolgee-compatible language code
 */
export const getTogloeeLanguageCode = (lang: string): string => {
  const languageMap: Record<string, string> = {
    zh: "zh-Hans",
    zhtw: "zh-Hant",
    zhhk: "zh-Hans-HK",
    en: "en",
    es: "es",
    fr: "fr",
    de: "de",
  };

  return languageMap[lang] || "en";
};

export default getTogloeeLanguageCode;
